import { Plus, Truck, Edit2, Trash2 } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Badge } from "../../components/ui/badge";

export default function SupplierSection({ suppliers, onCreate, onEdit, onDelete }) {
    return (
        <div className="space-y-3">
            <div className="flex justify-end">
                <Button onClick={onCreate} className="bg-[#FFCC00] hover:bg-[#E6B800] text-[#111827] font-bold rounded-sm" data-testid="sup-create-btn">
                    <Plus className="w-4 h-4 mr-1.5" /> Neuer Lieferant
                </Button>
            </div>

            {suppliers.length === 0 ? (
                <div className="bg-white border border-gray-200 rounded-sm p-12 text-center" data-testid="suppliers-empty">
                    <Truck className="w-12 h-12 text-gray-300 mx-auto mb-3" />
                    <div className="font-display font-black text-lg">Noch keine Lieferanten</div>
                    <p className="text-sm text-gray-500 mt-1">Legen Sie Ihren ersten Lieferanten an, um Artikel verknüpfen zu können.</p>
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="supplier-list">
                    {suppliers.map((s) => (
                        <div key={s.id} className={`bg-white border border-gray-200 rounded-sm p-4 hover:border-[#111827] transition-colors ${!s.is_active ? "opacity-60" : ""}`} data-testid={`sup-${s.id}`}>
                            <div className="flex items-start justify-between gap-2 mb-2">
                                <div className="min-w-0">
                                    {!s.is_active && (
                                        <Badge className="bg-gray-200 text-gray-700 text-[9px] uppercase rounded-sm mb-1">Inaktiv</Badge>
                                    )}
                                    <div className="font-display font-black text-base truncate">{s.name}</div>
                                    {s.contact_person && <div className="text-xs text-gray-600">{s.contact_person}</div>}
                                </div>
                                <div className="flex gap-1 shrink-0">
                                    <Button size="sm" variant="outline" onClick={() => onEdit(s)} className="h-7 text-[11px] rounded-sm" data-testid={`sup-edit-${s.id}`}>
                                        <Edit2 className="w-3 h-3" />
                                    </Button>
                                    <Button size="sm" variant="outline" onClick={() => onDelete(s.id)} className="h-7 text-[11px] rounded-sm text-red-700 hover:bg-red-50" data-testid={`sup-del-${s.id}`}>
                                        <Trash2 className="w-3 h-3" />
                                    </Button>
                                </div>
                            </div>
                            <div className="space-y-0.5 text-xs text-gray-600">
                                {s.email && <div>{s.email}</div>}
                                {s.phone && <div>{s.phone}</div>}
                                {s.city && <div>{s.zip} {s.city} · {s.country}</div>}
                                {s.customer_number && <div className="text-[10px] text-gray-500 mt-1">Kd-Nr.: {s.customer_number}</div>}
                            </div>
                            <div className="mt-2 flex gap-2 flex-wrap">
                                {s.payment_terms_days > 0 && <Badge className="bg-gray-100 text-gray-700 text-[9px] rounded-sm">{s.payment_terms_days} Tage Ziel</Badge>}
                                {s.skonto_percent > 0 && <Badge className="bg-green-100 text-green-800 text-[9px] rounded-sm">{s.skonto_percent}% Skonto · {s.skonto_days} Tg</Badge>}
                                {s.discount_percent > 0 && <Badge className="bg-blue-100 text-blue-800 text-[9px] rounded-sm">{s.discount_percent}% Rabatt</Badge>}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
